/* ═══════════════════════════════════════════════════
   BUNDLE BUILDER — Cart Drawer Progress Bar + Badge + Grouped Card
   Ported from the sibling "hpn-motion" theme's implementation of this
   same feature (never shipped to this repo — see config/settings_schema.json's
   "Bundle Builder — Cart" group, which existed there but wasn't wired to any
   JS here). Adapted for THIS theme's cart drawer, which is entirely
   different from Dawn's: assets/custom.js's drawerOpen()/refreshCartProgress()
   rebuild `.cart-summary__product-list` client-side via jQuery string
   templating from raw /cart.js data — never reading item.properties at all.
   That's why the "Bundle" badge (in snippets/cart-drawer.liquid, gated on
   item.properties._bundle_item) never actually appears after an add: it's
   real Liquid markup, but it only paints on a fresh full-page load, never
   on the AJAX-rebuilt drawer content the shopper actually sees. This file's
   job is to re-inject that badge (and drive the progress bar + grouped
   card) every time drawerOpen()/refreshCartProgress() finish rebuilding
   the list, by watching for the DOM change and reading /cart.js itself.

   NOTE — Discount application:
   Discounts are handled by a Shopify Discount Function that reads the
   _bundle_item and _bundle_id line-item properties set by
   bundle-builder-page.js. No client-side discount code needed here.
═══════════════════════════════════════════════════ */
(function initBundleBuilderCart() {
  'use strict';

  var bbBlock = document.getElementById('bbCartUpsell');
  if (!bbBlock) return; // settings.bb_enable is off — this whole feature stays off with it.

  var listEl = document.querySelector('.cart-summary__product-list');
  if (!listEl) return;

  /* ─────────────────────────────────────────────────
     ELIGIBLE PRODUCTS
  ───────────────────────────────────────────────── */
  var eligibleIds = [];
  var rawIds = (bbBlock.getAttribute('data-eligible-product-ids') || '').trim();
  if (rawIds) {
    eligibleIds = rawIds.split(',').map(function (id) { return id.trim(); }).filter(function (id) { return id && id !== '0'; });
  }

  var eligibleHandles = [];
  var rawHandles = (bbBlock.getAttribute('data-eligible-product-handles') || '').trim();
  if (rawHandles) {
    eligibleHandles = rawHandles.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  }

  var hasConfig = eligibleIds.length > 0 || eligibleHandles.length > 0;

  function isEligible(item) {
    if (eligibleIds.length && eligibleIds.some(function (id) { return String(item.product_id) === id; })) return true;
    if (eligibleHandles.length && item.handle && eligibleHandles.some(function (h) { return item.handle === h; })) return true;
    if (!hasConfig) return true;
    return false;
  }

  // A cart item only counts as part of the bundle if it was explicitly added
  // through the bundle builder page — identified by the _bundle_item line
  // property set by bundle-builder-page.js.
  function isBundleItem(item) {
    if (!item.properties) return false;
    return item.properties['_bundle_item'] === 'true' || item.properties['_bundle_item'] === true;
  }

  /* ─────────────────────────────────────────────────
     TIERS
  ───────────────────────────────────────────────── */
  var tiers = [];
  try {
    var rawTiers = JSON.parse(bbBlock.getAttribute('data-tiers') || '[]');
    tiers = rawTiers
      .filter(function (t) { return t.qty > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
  } catch (e) { tiers = []; }
  if (!tiers.length) {
    tiers = [
      { qty: 2, pct: 15, label: '2 products – 15% off' },
      { qty: 3, pct: 20, label: '3 products – 20% off' },
      { qty: 4, pct: 25, label: '4 products – 25% off' }
    ];
  }

  var maxQty = tiers[tiers.length - 1].qty;

  function getActiveTier(qty) {
    var active = null;
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].qty) { active = tiers[i]; break; }
    }
    return active;
  }

  /* ─────────────────────────────────────────────────
     PROGRESS BAR
  ───────────────────────────────────────────────── */
  function updateProgressBar(eligibleQty) {
    var fillBar = bbBlock.querySelector('[data-bb-fill]');
    var nextGrid = bbBlock.querySelector('[data-bb-next-grid]');
    var nextText = bbBlock.querySelector('[data-bb-next-text]');
    var unlockedEl = bbBlock.querySelector('[data-bb-unlocked-text]');
    var counterEl = bbBlock.querySelector('[data-bb-counter]');
    var tierLabels = bbBlock.querySelectorAll('[data-bb-tier-label]');

    var fillPct = Math.min(Math.round((eligibleQty / maxQty) * 100), 100);
    var clipPct = 100 - fillPct;

    if (fillBar) fillBar.style.width = fillPct + '%';
    if (nextGrid) nextGrid.style.clipPath = 'inset(0px ' + clipPct + '% 0px 0px)';
    if (counterEl) counterEl.textContent = '(' + eligibleQty + '/' + maxQty + ')';

    var unlockedTier = getActiveTier(eligibleQty);
    if (unlockedEl) {
      unlockedEl.textContent = unlockedTier ? unlockedTier.pct + '% off unlocked!' : '';
    }

    var nextTier = null;
    for (var j = 0; j < tiers.length; j++) {
      if (tiers[j].qty > eligibleQty) { nextTier = tiers[j]; break; }
    }
    if (nextText) {
      if (nextTier) {
        var need = nextTier.qty - eligibleQty;
        nextText.textContent = 'Add ' + need + ' more for ' + nextTier.pct + '% off';
      } else {
        nextText.textContent = 'Max discount unlocked! 🎉';
      }
    }

    tierLabels.forEach(function (lbl) {
      var tierQty = parseInt(lbl.getAttribute('data-tier-qty') || '0', 10);
      lbl.classList.toggle('is-active', unlockedTier !== null && tierQty <= eligibleQty);
    });
  }

  /* ─────────────────────────────────────────────────
     PER-ITEM "Bundle" BADGE
     assets/custom.js's drawerOpen()/refreshCartProgress() rebuild each row
     as <div class="cart-summary__product" id="product_<variantId>"> without
     ever looking at item.properties, so the badge markup that
     snippets/cart-drawer.liquid renders server-side never survives a
     rebuild. Recreate it here instead, matching that same static markup
     exactly, and keep its label in sync with the current tier.
  ───────────────────────────────────────────────── */
  function badgeMarkup() {
    var el = document.createElement('div');
    el.className = 'bb-cart-item-badge';
    el.setAttribute('data-bb-item-badge', '');
    el.innerHTML =
      '<svg class="bb-cart-item-badge__icon" viewBox="0 0 16 16" fill="none" width="11" height="11" aria-hidden="true">' +
        '<path d="M2 8L6 12L14 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="bb-cart-item-badge__label">Bundle</span>';
    return el;
  }

  function insertOrUpdateBadge(rowEl, originalPrice, label) {
    var badge = rowEl.querySelector('[data-bb-item-badge]');
    if (!badge) {
      badge = badgeMarkup();
      var variantGroup = rowEl.querySelector('.cart-summary__variantgroup');
      if (variantGroup && variantGroup.parentNode) {
        variantGroup.parentNode.insertBefore(badge, variantGroup.nextSibling);
      } else {
        rowEl.querySelector('.cart-summary__product__description').appendChild(badge);
      }
    }
    badge.setAttribute('data-item-original-price', originalPrice);
    var labelEl = badge.querySelector('.bb-cart-item-badge__label');
    if (labelEl) labelEl.textContent = label;
  }

  function removeBadge(rowEl) {
    var badge = rowEl.querySelector('[data-bb-item-badge]');
    if (badge) badge.parentNode.removeChild(badge);
  }

  function updateBadges(bundleItems, tierPct) {
    var label = tierPct ? 'Bundle – ' + tierPct + '% off' : 'Bundle';
    var seenVariantIds = {};

    bundleItems.forEach(function (item) {
      seenVariantIds[item.variant_id] = true;
      var rowEl = document.getElementById('product_' + item.variant_id);
      if (rowEl) insertOrUpdateBadge(rowEl, item.original_price, label);
    });

    // Strip stale badges off any row that's no longer part of a bundle
    // (e.g. the bundle was removed but the same variant is still in cart
    // as a plain item, or the row id got reused after a previous bundle
    // item was removed).
    listEl.querySelectorAll('[data-bb-item-badge]').forEach(function (badge) {
      var rowEl = badge.closest('.cart-summary__product');
      var variantId = rowEl && rowEl.id.replace('product_', '');
      if (!variantId || !seenVariantIds[variantId]) removeBadge(rowEl || badge.parentNode);
    });
  }

  /* ─────────────────────────────────────────────────
     BUNDLE GROUP CARD
     Lives in #bb-group-card-anchor — a sibling of
     .cart-summary__product-list inserted in
     snippets/cart-drawer.liquid, right before it, so
     drawerOpen()/refreshCartProgress() (which only ever
     replace .cart-summary__product-list's innerHTML) never
     touch the anchor and the card is never destroyed by a
     rebuild.

     Matches API bundle items to their DOM rows by variant id
     (#product_<variantId> — see custom.js's drawerOpen(), which
     is the only id each row gets; this theme's cart JSON-templating
     has no per-line "key" attribute to key off of the way Dawn's
     data-key does, so two bundle instances that happen to share a
     variant would collide here — an existing limitation of this
     cart markup, not something introduced by this file).
  ───────────────────────────────────────────────── */

  var savedCardKey = null;
  var bundleLineKeys = []; // cart line `key`s (from /cart.js) — always fresh, used for removal only.
  var isGroupingItems = false;

  var removeBundleInFlight = false;

  function refreshWholeDrawer() {
    if (typeof window.refreshCartProgress === 'function') window.refreshCartProgress();
    if (typeof window.drawerOpen === 'function') window.drawerOpen();
  }

  function removeBundle() {
    if (!bundleLineKeys.length || removeBundleInFlight) return;
    removeBundleInFlight = true;

    var keysToRemove = bundleLineKeys.slice();
    var updates = {};
    keysToRemove.forEach(function (k) { updates[k] = 0; });

    var btn = document.querySelector('.bb-group-card__remove-btn');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    listEl.classList.add('bb-cloaked');
    window.setTimeout(function () { listEl.classList.remove('bb-cloaked'); }, 4000);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      })
      .then(function () {
        removeBundleInFlight = false;
        bundleLineKeys = [];
        savedCardKey = null;
        refreshWholeDrawer();
      })
      .catch(function () {
        removeBundleInFlight = false;
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        listEl.classList.remove('bb-cloaked');
        fetchCartAndSync();
      });
  }

  var removeLineItemInFlight = false;

  function removeLineItem(key) {
    if (!key || removeLineItemInFlight) return;
    removeLineItemInFlight = true;

    var btn = document.querySelector('.bb-group-card__slide-remove[data-key="' + key + '"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    listEl.classList.add('bb-cloaked');
    window.setTimeout(function () { listEl.classList.remove('bb-cloaked'); }, 4000);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: (function () { var u = {}; u[key] = 0; return u; })() })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      })
      .then(function () {
        removeLineItemInFlight = false;
        bundleLineKeys = bundleLineKeys.filter(function (k) { return k !== key; });
        savedCardKey = null;
        refreshWholeDrawer();
      })
      .catch(function () {
        removeLineItemInFlight = false;
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        listEl.classList.remove('bb-cloaked');
        fetchCartAndSync();
      });
  }

  function buildSlidesHTML(bundleItems) {
    var slides = [];
    bundleItems.forEach(function (item) {
      var imgHTML = item.imgSrc
        ? '<img src="' + item.imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="72" height="72" loading="lazy">'
        : '<div class="bb-group-card__img-placeholder"></div>';
      var slideHTML = (
        '<div class="bb-group-card__slide">' +
          '<div class="bb-group-card__img-wrap">' +
            imgHTML +
            '<button type="button" class="bb-group-card__slide-remove" data-key="' + item.key + '" aria-label="Remove ' + item.title.replace(/"/g, '&quot;') + '">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/></svg>' +
            '</button>' +
          '</div>' +
          '<span class="bb-group-card__name">' + item.title + '</span>' +
        '</div>'
      );
      for (var i = 0; i < item.qty; i++) {
        slides.push(slideHTML);
      }
    });
    return slides.join('');
  }

  function bindSlideRemoveButtons(carousel) {
    carousel.querySelectorAll('.bb-group-card__slide-remove').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        removeLineItem(btn.getAttribute('data-key'));
      });
    });
  }

  function initDragScroll(el) {
    if (!el) return;
    var isDown = false;
    var startX, scrollLeftStart;
    var canDrag = false;

    function updateCursor() {
      canDrag = el.scrollWidth > el.clientWidth;
      el.style.cursor = canDrag ? 'grab' : 'default';
    }
    updateCursor();
    if (window.ResizeObserver) new ResizeObserver(updateCursor).observe(el);

    el.addEventListener('mousedown', function (e) {
      if (!canDrag || e.button !== 0) return;
      isDown = true;
      startX = e.pageX;
      scrollLeftStart = el.scrollLeft;
      el.classList.add('is-grabbing');
      document.body.style.userSelect = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      el.scrollLeft = scrollLeftStart - (e.pageX - startX);
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-grabbing');
      document.body.style.userSelect = '';
    });
  }

  function uncloak() {
    listEl.classList.remove('bb-cloaked');
  }

  function groupBundleItems(bundleCartItems) {
    var anchor = document.getElementById('bb-group-card-anchor');
    if (!anchor) { uncloak(); return; }

    isGroupingItems = true;

    // PHASE 1: unhide previously hidden rows (a rebuild may have re-created them).
    listEl.querySelectorAll('.cart-summary__product[data-bb-hidden]').forEach(function (el) {
      el.removeAttribute('data-bb-hidden');
      el.style.display = '';
    });

    // PHASE 2: match API bundle items to DOM rows by variant id.
    var bundleItems = [];
    if (bundleCartItems && bundleCartItems.length) {
      bundleCartItems.forEach(function (apiItem) {
        var node = document.getElementById('product_' + apiItem.variant_id);

        var imgSrc = apiItem.featured_image && apiItem.featured_image.url ? apiItem.featured_image.url : '';
        if (!imgSrc && node) {
          var imgEl = node.querySelector('img');
          imgSrc = imgEl ? (imgEl.getAttribute('src') || '') : '';
        }
        if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;

        bundleItems.push({
          node: node,
          key: apiItem.key,
          title: apiItem.product_title || apiItem.title || '',
          imgSrc: imgSrc,
          qty: apiItem.quantity
        });
      });
    }

    // PHASE 2.5: if the DOM hasn't caught up yet, bail — the observer will
    // fire again once drawerOpen()/refreshCartProgress() finish painting.
    // Deliberately NOT uncloaking here — staying cloaked is the whole point:
    // it's what keeps the individual (ungrouped) rows from flashing on
    // screen for the one paint cycle between custom.js's rebuild landing and
    // this function's own retry catching up with it.
    var missingNodes = bundleItems.length > 0 && bundleItems.some(function (it) { return !it.node; });
    if (missingNodes) {
      isGroupingItems = false;
      return;
    }

    var existingCard = anchor.querySelector('.bb-group-card');

    if (!bundleItems.length) {
      if (existingCard) existingCard.remove();
      savedCardKey = null;
      uncloak();
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { isGroupingItems = false; }); });
      return;
    }

    var totalQty = bundleItems.reduce(function (sum, it) { return sum + it.qty; }, 0);
    var activeTier = getActiveTier(totalQty);
    var tierPct = activeTier ? activeTier.pct : 0;
    var hasSubscription = bundleCartItems.some(function (it) {
      return it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
    });
    var fingerprint = bundleItems.map(function (it) { return it.key + ':' + it.qty; }).join('|') + '@' + tierPct + (hasSubscription ? '+sub' : '');

    if (!existingCard) {
      existingCard = document.createElement('div');
      existingCard.className = 'bb-group-card';
      existingCard.innerHTML =
        '<div class="bb-group-card__header">' +
          '<span class="bb-group-card__title"></span>' +
          '<span class="bb-group-card__tier-label"></span>' +
          '<span class="bb-group-card__sub-badge" style="display:none">' +
            '<svg class="bb-group-card__sub-icon" width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M11.5 1C11.776 1 12 1.224 12 1.5V2.5H13C14.105 2.5 15 3.395 15 4.5V13C15 14.105 14.105 15 13 15H3C1.895 15 1 14.105 1 13V4.5C1 3.395 1.895 2.5 3 2.5H4V1.5C4 1.224 4.224 1 4.5 1C4.776 1 5 1.224 5 1.5V2.5H11V1.5C11 1.224 11.224 1 11.5 1ZM2 6.5V13C2 13.552 2.448 14 3 14H13C13.552 14 14 13.552 14 13V6.5H2ZM3 3.5C2.448 3.5 2 3.948 2 4.5V5.5H14V4.5C14 3.948 13.552 3.5 13 3.5H3Z" fill="currentColor"/></svg>' +
            'Subscription' +
          '</span>' +
          '<button type="button" class="bb-group-card__remove-btn" aria-label="Remove bundle" title="Remove all bundle items">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="bb-group-card__carousel" data-bb-carousel></div>';
      existingCard.querySelector('.bb-group-card__remove-btn').addEventListener('click', function (e) {
        e.stopPropagation();
        removeBundle();
      });
      anchor.appendChild(existingCard);
      initDragScroll(existingCard.querySelector('[data-bb-carousel]'));
    }

    if (savedCardKey !== fingerprint) {
      var titleEl = existingCard.querySelector('.bb-group-card__title');
      if (titleEl) titleEl.textContent = 'Bundle (' + totalQty + ' item' + (totalQty !== 1 ? 's' : '') + ')';
      var tierEl = existingCard.querySelector('.bb-group-card__tier-label');
      if (tierEl) tierEl.textContent = activeTier ? tierPct + '% off unlocked' : 'Bundle';
      var subBadge = existingCard.querySelector('.bb-group-card__sub-badge');
      if (subBadge) subBadge.style.display = hasSubscription ? '' : 'none';
      var carousel = existingCard.querySelector('[data-bb-carousel]');
      if (carousel) {
        carousel.innerHTML = buildSlidesHTML(bundleItems);
        bindSlideRemoveButtons(carousel);
        initDragScroll(carousel);
      }
      savedCardKey = fingerprint;
    }

    // Hide the matched individual rows now that the grouped card represents them.
    bundleItems.forEach(function (item) {
      if (!item.node) return;
      item.node.setAttribute('data-bb-hidden', '1');
      item.node.style.display = 'none';
    });

    // Only safe to reveal the list now — every bundle row is confirmed
    // hidden and the group card is in place, so there's nothing ungrouped
    // left for the reveal to expose.
    uncloak();
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { isGroupingItems = false; }); });
  }

  /* ─────────────────────────────────────────────────
     SYNC
  ───────────────────────────────────────────────── */
  function syncVisibility(cartItems) {
    if (!cartItems || !cartItems.length) {
      bbBlock.style.display = 'none';
      bundleLineKeys = [];
      isGroupingItems = false;
      groupBundleItems([]);
      return;
    }

    var bundleItems = cartItems.filter(isBundleItem);
    var bundleQty = bundleItems.reduce(function (sum, it) { return sum + it.quantity; }, 0);

    bundleLineKeys = bundleItems.map(function (it) { return it.key; });

    if (bundleQty < 1) {
      bbBlock.style.display = 'none';
      isGroupingItems = false;
      groupBundleItems([]);
      return;
    }

    var activeTier = getActiveTier(bundleQty);
    updateProgressBar(bundleQty);
    updateBadges(bundleItems, activeTier ? activeTier.pct : 0);
    bbBlock.style.display = '';
    groupBundleItems(bundleItems);
  }

  var syncDebounceTimer = null;

  function fetchCartAndSync() {
    window.clearTimeout(syncDebounceTimer);
    syncDebounceTimer = window.setTimeout(function () {
      isGroupingItems = false;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { syncVisibility(cart.items); })
        .catch(function () { isGroupingItems = false; });
    }, 60);
  }

  /* ─────────────────────────────────────────────────
     EVENT LISTENERS
     Watch .cart-summary__product-list — assets/custom.js's
     drawerOpen()/refreshCartProgress() replace its innerHTML on every
     cart update (add/remove/qty change) AND on drawer open (both call
     drawerOpen(), which always rebuilds the list even when nothing
     changed). One observer on that single node covers both cases.
  ───────────────────────────────────────────────── */
  new MutationObserver(function (mutations) {
    if (isGroupingItems) return;
    var isOwnMutation = mutations.every(function (m) {
      if (m.type === 'attributes') {
        return m.target.hasAttribute && (m.target.hasAttribute('data-bb-hidden') || m.attributeName === 'data-bb-hidden');
      }
      return false;
    });
    if (isOwnMutation) return;

    // MutationObserver callbacks run as a microtask, before the browser's
    // next paint — adding the cloak class here (synchronously, not inside
    // fetchCartAndSync's 60ms-debounced fetch) is what actually keeps the
    // individual rows custom.js just rebuilt from ever being painted
    // ungrouped. Only worth doing if we already know a bundle exists —
    // otherwise this would flash-hide an unrelated cart-wide rebuild (a
    // qty change on a non-bundle item, say) with nothing to show for it.
    if (bundleLineKeys.length > 0) {
      listEl.classList.add('bb-cloaked');
      window.setTimeout(uncloak, 3000); // safety net if sync never completes
    }

    fetchCartAndSync();
  }).observe(listEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bb-hidden'] });

  fetchCartAndSync();
})();
